import { Button, LinearProgress, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";

const PatientAssistantProgressDialog = ({ open, job, statusMeta, severity, onClose }) => {
    const [animatedDots, setAnimatedDots] = useState('.');

    useEffect(() => {
        if (!open) {
            setAnimatedDots('.');
            return undefined;
        }

        const frames = ['.', '..', '...'];
        const intervalId = setInterval(() => {
            setAnimatedDots((currentValue) => {
                const currentIndex = frames.indexOf(currentValue);
                const nextIndex = currentIndex === -1 || currentIndex === frames.length - 1
                    ? 0
                    : currentIndex + 1;
                return frames[nextIndex];
            });
        }, 450);

        return () => clearInterval(intervalId);
    }, [open]);

    if (!job || !statusMeta) {
        return null;
    }

    const safeProgress = Math.max(0, Math.min(100, job.progress || 0));

    return (
        <ResponsiveDialog
            isOpen={open}
            onClose={onClose}
            title={(
                <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center">
                    <Typography component="span" variant="inherit" fontWeight="inherit">
                        In elaborazione
                    </Typography>
                    <Typography component="span" variant="inherit" fontWeight="inherit" sx={{ color: '#2196f3', minWidth: '1.8ch' }}>
                        {animatedDots}
                    </Typography>
                </Stack>
            )}
            minWidth="560px"
            minHeight="auto"
            titleFontSize={{ xs: '1.3rem', sm: '1.6rem' }}
            actions={(
                <Button onClick={onClose}>
                    Continua in background
                </Button>
            )}
        >
            <Stack spacing={2.5} width="100%" minWidth={{ xs: '100%', sm: '460px' }}>
                <Stack spacing={1} alignItems="center">
                    <Typography variant="h3" fontWeight="bold">
                        {safeProgress}%
                    </Typography>
                    <Typography variant="body1" textAlign="center">
                        {statusMeta.description}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.72 }} textAlign="center">
                        Puoi attendere il completamento dell'analisi oppure continuare a usare la pagina.
                    </Typography>
                </Stack>

                <Stack spacing={1}>
                    <LinearProgress variant="determinate" value={safeProgress} sx={{ height: 10, borderRadius: 999 }} />
                    <Stack direction="row" justifyContent="flex-start" alignItems="center">
                        <Typography variant="body2" sx={{ opacity: 0.72 }}>
                            Avanzamento analisi
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
        </ResponsiveDialog>
    );
};

export default PatientAssistantProgressDialog;
